import { getField, updateField } from 'vuex-map-fields';
import moment from 'moment';

const state = {
    presupuestoInternoId: 0,
    cliente: '',
    accion: '',
    importe: 0,
};

const mutations = {
    updateField,

    'INICIALIZAR'(state) {
        state.presupuestoInternoId = 0;
        state.cliente = '';
        state.accion = '';
        state.importe = 0;
    },
    'SET_TRANSFERENCIA_PREMIOS_PRESUPUESTO'(state, params) {
        state.presupuestoInternoId = params.presupuestoInternoId;
        state.cliente = params.cliente;
        state.accion = params.accion;
        state.importe = params.importe;
    },

};

const getters = {
    getField,

    transferenciaPremiosPresupuesto (state) {
        return {
            presupuestoInternoId: parseInt(state.presupuestoInternoId),
            cliente: state.cliente,
            accion: state.accion,
            importe: parseFloat(state.importe),
        }
    }
};

const actions = {
    inicializar ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR');

            if (params) {
                commit('SET_TRANSFERENCIA_PREMIOS_PRESUPUESTO', params);
                resolve();
            } else {
                resolve();
            }
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}